import { Link } from 'react-router-dom';
import { DATA_MANAGER_HOME, DATA_MANAGER_WORKSPACE_LABEL } from '../../constants/setupRoadmapSteps';
import styles from './SetupRoadmap.module.css';

/**
 * Admin landing page at /admin. Links to Setup Roadmap and Data Manager workspace.
 */
function AdminLanding() {
    return (
        <div className={styles.container}>
            <h1>BDSA Administration</h1>
            <p className={styles.intro}>
                Choose an area to configure or manage.
            </p>

            <div className={styles.stepsGrid}>
                <div className={styles.stepCard}>
                    <div className={styles.stepHeader}>
                        <div className={styles.stepNumber}>1</div>
                        <div className={styles.stepInfo}>
                            <h2 className={styles.stepTitle}>Setup Roadmap</h2>
                        </div>
                    </div>
                    <p className={styles.stepDescription}>
                        Configure your BDSA server: initial config, network connectivity, agents, and CILogon.
                    </p>
                    <Link to="/admin/setup" className={styles.stepLink}>
                        Open Setup Roadmap
                    </Link>
                </div>

                <div className={styles.stepCard}>
                    <div className={styles.stepHeader}>
                        <div className={styles.stepNumber}>2</div>
                        <div className={styles.stepInfo}>
                            <h2 className={styles.stepTitle}>{DATA_MANAGER_WORKSPACE_LABEL}</h2>
                        </div>
                    </div>
                    <p className={styles.stepDescription}>
                        Define stains, regions, and protocols, then build cases in Case Builder.
                        Shared with Data Managers.
                    </p>
                    <Link to={DATA_MANAGER_HOME} className={styles.stepLink}>
                        Open {DATA_MANAGER_WORKSPACE_LABEL}
                    </Link>
                </div>
            </div>
        </div>
    );
}

export default AdminLanding;
